// Which navigation destinations a user sees, and in what order. Pure selector
// over the resolved gates — the caller does the (impure) flag evaluation and
// entitlement lookup, this just encodes the policy. Icon-free and router-free
// so it stays in the data layer; MobileTabBar / Sidebar map id -> icon + route.
//
// Order mirrors the desktop sidebar: Dashboard, History, Logs, Alerts, PdM.
// With every gate on that's five tabs — the bottom tab bar's ceiling.

export type DestinationId = 'dashboard' | 'history' | 'logs' | 'alerts' | 'pdm';

export interface NavDestination {
  id: DestinationId;
  to: string;
  label: string;
}

export interface NavGates {
  /** evaluateFlag('alerts-page', ctx). */
  alertsEnabled: boolean;
  /** pdm-page flag AND the company's PdM entitlement (both required). */
  pdmEnabled: boolean;
}

export function navDestinations(gates: NavGates): NavDestination[] {
  const out: NavDestination[] = [
    { id: 'dashboard', to: '/', label: 'Dashboard' },
    { id: 'history', to: '/history', label: 'History' },
    { id: 'logs', to: '/logs', label: 'Logs' },
  ];
  if (gates.alertsEnabled) out.push({ id: 'alerts', to: '/alerts', label: 'Alerts' });
  if (gates.pdmEnabled) out.push({ id: 'pdm', to: '/pdm', label: 'PdM' });
  return out;
}
